<template>
  <div class="custom-search">
    <van-search   @search="handleSearch" :clearable="false" v-model="inputValue" placeholder="请输入关键词搜索" @focus="handleFocus" @blur="handleBlur"
      @clear="handleClear" />
    <!-- 根据输入内容展示关闭按钮 -->
    <van-button  @click="handleSearch"  v-if="inputValue && inputValue.length > 0" class="submitBtn" round block type="primary" native-type="submit">
      搜索
    </van-button>
    <van-icon
      v-if="inputValue && inputValue.length > 0"
      name="cross"
      class="search-clear-icon" 
      @click="clearInput"
    />
  </div>
</template>
  
<script>
export default {
  props: {
    value: String, // 父组件传入的 v-model 绑定的值
    placeholder: String, // 输入框的 placeholder
    redirect: Boolean, // 参数，是否跳转到其他页面
  },
  data() {
    return {
      inputValue: "", // 内部维护的输入框值
    };
  },
  methods: {
    // 处理搜索事件，向父组件触发搜索事件
    handleSearch() {
      this.$emit("search", this.inputValue);
    },
    // 处理输入框聚焦事件
    handleFocus() {
      if (this.redirect) {
        this.$emit("gotoSearchList")
        // 如果需要跳转到其他页面，可以在这里处理

      }
    },
    // 处理输入框失焦事件
    handleBlur() {
      // 处理失焦时的逻辑
    },
    // 处理清空输入框事件
    handleClear() {
      this.inputValue = "";
      this.$emit("search", "",true); // 清空时也触发搜索事件，通知父组件清空搜索结果
    },
    // 点击清空按钮
    clearInput() {
      this.inputValue = "";
      this.$emit("search", "",true); // 清空时也触发搜索事件，通知父组件清空搜索结果
    },
  },
  watch: {
    value(newVal) {
      // 当父组件传入的 value 发生变化时，更新内部维护的输入框值
      this.inputValue = newVal;
    },
  },
};
</script>
  
<style scoped lang="less">
.custom-search {
  position: relative;
}
.custom-search .van-search__content {
  height: 40px; /* 自定义高度 */
  display: flex;
  align-items: center; /* 垂直居中 */
  border: 1px solid #F3F3F3;
}

.custom-search .van-field__control {
  line-height: normal; /* 重置行高 */
}


::v-deep .van-field__clear {
  font-size: 30px;
}

::v-deep .van-icon-clear:before {
  content: '\e6a7' !important;
}

.search-clear-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 90px;
  font-size: 16px;
  cursor: pointer;
}

.submitBtn {
  position: absolute;
  right: 3px;
  top: 4px;
  border: none;
  width: 72px;
  height: 32px;
  background: #0059A3;
  font-size: 14px;
  color: #FFFFFF;

}

  .van-search {
    padding: 0;
  background: transparent !important;

  .van-search__content {
    background: #F3F3F3;
    border-radius: 100px;
  }
 /deep/ .van-field__control{
    color: #96969a !important;
  }
  /deep/ .van-field__control::placeholder{
    color: #96969a !important;
  }
}
</style>